import React from "react";
import { Icon } from "../core/Icon.jsx";

/* Info row — label (left) + value (right). The Display spec's core pattern:
   text data left-aligns, numbers right-align (value is right by default).
   Use inside cards for key/value summaries. */
export function InfoRow({ label, value, hint, mono = false, divider = true, valueColor, style, ...rest }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        minHeight: 40,
        padding: "10px 0",
        borderBottom: divider ? "1px solid var(--divider)" : "none",
        ...style,
      }}
      {...rest}
    >
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontFamily: "var(--font-sans)", fontWeight: 500, fontSize: 14, color: "var(--text-muted)" }}>
        {label}
        {hint ? <Icon name="info" size={14} color="var(--grey-mid)" /> : null}
      </span>
      <span
        className="tnum"
        style={{
          fontFamily: mono ? "var(--font-mono)" : "var(--font-sans)",
          fontWeight: 600,
          fontSize: 14,
          color: valueColor || "var(--text-body)",
          textAlign: "right",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {value}
      </span>
    </div>
  );
}

export default InfoRow;
